import { render, staticRenderFns } from "./startStudy.vue?vue&type=template&id=45889fd8&scoped=true"
import script from "./startStudy.vue?vue&type=script&lang=js"
export * from "./startStudy.vue?vue&type=script&lang=js"
import style0 from "./startStudy.vue?vue&type=style&index=0&id=45889fd8&prod&scoped=true&lang=scss"
import style1 from "./startStudy.vue?vue&type=style&index=1&id=45889fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45889fd8",
  null
  
)

export default component.exports